function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M10.3264 4.21709C10.759 3.5039 11.5326 3.06836 12.3667 3.06836C13.2009 3.06836 13.9745 3.5039 14.4071 4.21709L14.4092 4.22065L21.3454 15.8001C21.7694 16.5343 21.7719 17.4385 21.352 18.1752C20.9321 18.9118 20.1528 19.3703 19.305 19.3797L19.2967 19.3797L5.4285 19.3797C4.58063 19.3704 3.80139 18.9118 3.3815 18.1752C2.96162 17.4385 2.96415 16.5344 3.38815 15.8001L3.39416 15.7897L10.3264 4.21709ZM11.6098 4.99352C11.6095 4.99403 11.6092 4.99453 11.6089 4.99503L4.6846 16.5546C4.52965 16.8266 4.52956 17.1602 4.68467 17.4324C4.84006 17.705 5.12794 17.875 5.44152 17.8797H19.292C19.6055 17.875 19.8934 17.705 20.0488 17.4324C20.2039 17.1602 20.2038 16.8266 20.0489 16.5546L13.1246 4.99503C13.1243 4.99453 13.124 4.99403 13.1237 4.99352C12.9628 4.72952 12.676 4.56836 12.3667 4.56836C12.0575 4.56836 11.7707 4.72952 11.6098 4.99352Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M12.3672 8.06152C12.7814 8.06152 13.1172 8.39731 13.1172 8.81152V12.0843C13.1172 12.4985 12.7814 12.8343 12.3672 12.8343C11.953 12.8343 11.6172 12.4985 11.6172 12.0843V8.81152C11.6172 8.39731 11.953 8.06152 12.3672 8.06152Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M11.6172 15.3564C11.6172 14.9422 11.953 14.6064 12.3672 14.6064H12.3754C12.7896 14.6064 13.1254 14.9422 13.1254 15.3564C13.1254 15.7707 12.7896 16.1064 12.3754 16.1064H12.3672C11.953 16.1064 11.6172 15.7707 11.6172 15.3564Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var SvgIconWarning = function SvgIconWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Warning.6c6030ae.svg";
export { ForwardRef as ReactComponent };